<template>
    <div>

        <div v-if="media_chan == 1 && (audience === 1 || audience === 2 || audience === 5)">
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Delivery Method <span id="approved">*</span>:
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="deliverymethods" outlined dense attach v-model="delivery_method" />
                </v-col>
            </v-row>
        </div>
        <div v-if="getDeliveryMethod === 1 || getDeliveryMethod === 3 || getDeliveryMethod === 7">
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Delivery Type :
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="deliveryTypes" outlined dense attach v-model="delivery_type" />
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Postage :
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="postageTypes" outlined dense attach v-model="postage" />
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Pre-Sorted :
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="preSortedTypes" outlined dense attach v-model="pre_sorted" />
                </v-col>
            </v-row>
            <v-row id="product__rowpadding">
                <v-col :cols="4" class="label-field text-left no-right no-bottom">
                    Package-Type :
                </v-col>
                <v-col :cols="6" class="text-left no-left no-bottom no-top">
                    <v-select :items="packageTypes" outlined dense attach v-model="package_type" />
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: 'Delivery',
    data: () => ({
        items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
        // delivery_types: [{text:'Select One',value:''},{text:'First Class',value:2},{text:'Marketing Mail/Standard',value:1},{text:'Non-Profit',value:3}],
        // postage_types: [{text:'Select One',value:''},{text:'Company Name',value:2},{text:'Permit #',value:1},{text:'Stamp',value:3}],
        // pre_sorted_types: [{text:'Select One',value:''},{text:'yes',value:1},{text:'No',value:2},{text:'N/A',value:3}],
        // package_types: [{text:'Select One',value:''},{text:'Postcard',value:1},{text:'Envelope',value:2},{text:'Self-Mailer',value:3}],
        watchdelivery: '',
        delivery: '',
        // delivery_method: '',
        // delivery_type: '',
        // postage: '',
        // pre_sorted: '',
        // package_type: '',
    }),
    computed: {
        ...mapGetters({
            deliverymethods: 'ProductData/getAllDeliveryType',
            media_chan: 'ProductData/getStateMediaChannel',
            audience: 'ProductData/getStateAudience',
            deliveryTypes: 'ProductData/getAllDeliveryTypes',
            postageTypes: 'ProductData/getAllPostageTypes',
            preSortedTypes: 'ProductData/getAllPreSortedTypes',
            packageTypes: 'ProductData/getAllPackageTypes',
            getDeliveryMethod: 'ProductData/getDeliveryMethod',
        }),
        delivery_method: {
            get: function () {
                return this.$store.getters['ProductData/getDeliveryMethod']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/set_delivery_method', o)
            },
        },
        delivery_type: {
            get: function () {
                return this.$store.getters['ProductData/getDeliveryType']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/set_delivery_type', o)
            },
        },
        postage: {
            get: function () {
                return this.$store.getters['ProductData/getDeliveryPostage']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/set_delivery_postage', o)
            },
        },
        pre_sorted: {
            get: function () {
                return this.$store.getters['ProductData/getDeliveryPreSorted']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/set_delivery_pre_sorted', o)
            },
        },
        package_type: {
            get: function () {
                return this.$store.getters['ProductData/getDeliveryPackageType']
            },
            set: function (o) {
                this.$store.dispatch('ProductData/set_delivery_package_type', o)
            },
        },
    },
    methods: {
        emit_delivery: function () {
            this.$emit('set', this.delivery)
        }
    },
    // watch: {
    //     delivery_method: function(o) {
    //         //this.delivery = o
    //         //this.$emit('set_delivery_method', o)
    //         this.$store.dispatch('ProductData/set_delivery_method', o)
    //     },
    //     delivery_type: function(o) {
    //         this.$store.dispatch('ProductData/set_delivery_type', o)
    //     },
    //     postage: function(o) {
    //         this.$store.dispatch('ProductData/set_delivery_postage', o)
    //     },
    //     pre_sorted: function(o) {
    //         this.$store.dispatch('ProductData/set_delivery_pre_sorted', o)
    //     },
    //     package_type: function(o) {
    //         this.$store.dispatch('ProductData/set_delivery_package_type', o)
    //     },
    // }
}
</script>